module.exports = __webpack_public_path__ + "img/csr_swiper_07_mobile.c5207dc9.jpg";